import { render, staticRenderFns } from "./TableRiskAppraisalEp_3x3.vue?vue&type=template&id=11f07ea0&scoped=true"
import script from "./TableRiskAppraisalEp_3x3.vue?vue&type=script&lang=js"
export * from "./TableRiskAppraisalEp_3x3.vue?vue&type=script&lang=js"
import style0 from "./TableRiskAppraisalEp_3x3.vue?vue&type=style&index=0&id=11f07ea0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f07ea0",
  null
  
)

export default component.exports